import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../../models/api-url.model';
import {
    BanLookupRequest,
    BanLookupUpdateResponse,
} from '../../models/ban-lookup.model';
import { ApiService } from '../../core/services/api';

@Injectable({
  providedIn: 'root',
})
export class BanLookupService {
  private apiService = inject(ApiService);

  updateBanLookup(
    banLookup: BanLookupRequest,
  ): Observable<BanLookupUpdateResponse[]> {
    return this.apiService.put(
      `${api.banLookupsURL}/${banLookup.Id}`,
      banLookup,
    );
  }

  deleteLocationAlias(
    banLookupId: string,
  ): Observable<BanLookupUpdateResponse[]> {
    return this.apiService.patch(
      `${api.banLookupsURL}/${banLookupId}/location-alias`,
      banLookupId,
    );
  }
}
